// Auto-generated skeleton for Account

import { Building } from "./Building";
import { AccountName } from "./AccountName";
import { AccountingYear } from "./AccountingYear";
import { AccountBalance } from "./AccountBalance";
import { Journal } from "./Journal";

export const Account: Api.Account = {
  id: 0,
  hp_id: null,
  account_name_id: 0,
  building_id: 0,
  contra_account_id: 0,
  accounting_year_id: 0,
  account_type: 'K',
  comments_count: 0,
  journals_count: 0,
  building: Building,
  account_name: AccountName,
  accounting_year: AccountingYear,
  balances: [AccountBalance],
  review_documents: [],
  journals: Journal,
  created: null,
  updated: null,
};

